export default __webpack_public_path__ + "static/ip-transit-main-graph-5315ac27d5bcf3140d059f50dfdd205a.svg";